import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Loader from 'components/loader/Loader';

const ZAPIER_WIDGET_CONTAINER_ID = 'zapier-widget-container';

const ZapierWidget = () => {
  const { t } = useTranslation();
  const [isLoadingScript, setIsLoadingScript] = useState(true);

  useEffect(() => {
    // Load Zapier widget script
    const script = document.createElement('script');
    script.src =
      'https://zapier.com/apps/embed/widget.js?services=hostfully&borderColor=none&buttonColor=%23337ab7&inheritFont=true&limit=10';
    script.async = true;

    script.onload = () => {
      setIsLoadingScript(false);
    };

    const container = document.getElementById(ZAPIER_WIDGET_CONTAINER_ID);

    if (container) {
      container.appendChild(script);
    }

    return () => {
      // Cleanup script when component unmounts
      if (container && container.contains(script)) {
        container.removeChild(script);
      }
    };
  }, []);

  return (
    <div id={ZAPIER_WIDGET_CONTAINER_ID}>
      <h1>{t('pageIntegrations.integrationDetails.zapier.zapTemplates')}</h1>

      <p>
        {t(
          'pageIntegrations.integrationDetails.zapier.zapTemplatesDescription',
        )}
      </p>

      {isLoadingScript && <Loader />}
    </div>
  );
};

export default ZapierWidget;
